import { APIService } from "./APIService"
import { LoginType, ProfileCompanyType, VIESType } from "./types"

const login = (username: string, password: string) =>
  APIService.post<null, LoginType>(`/login`, {
    username,
    password,
  })

const verify = () => APIService.post<null, LoginType>(`/verify`)

const register = (username: string, password: string, params?: object) =>
  APIService.post<null, LoginType>(`/register`, { ...params, username, password })

const changePassword = (email: string) =>
  APIService.post<null, null>(`/change-password?email=${email}`)

const getCompanyFromGUS = (nip: string) =>
  APIService.get<null, ProfileCompanyType>(`/gus?nip=${nip}`)

const getCompanyFromVIES = (number: string) =>
  APIService.get<null, VIESType>(`https://autocomplete-s3vfaujxlq-uc.a.run.app?input=${number}`)

export const PublicService = {
  login,
  verify,
  register,
  changePassword,
  getCompanyFromGUS,
  getCompanyFromVIES,
}
